export const WHATSAPP_TEMPLATE_STATUS_LABELS = {
  PENDING: 'Pendiente',
  APPROVED: 'Aprobada',
  REJECTED: 'Rechazada',
};

export const WHATSAPP_TEMPLATE_STATUS_COLORS = {
  PENDING: 'orange lighten-4',
  APPROVED: 'green lighten-4',
  REJECTED: 'red lighten-4',
};

export const WHATSAPP_TEMPLATE_STATUS_TEXT_COLORS = {
  PENDING: 'orange darken-4',
  APPROVED: 'green darken-4',
  REJECTED: 'red darken-4',
};

const UNIVERSAL_WHATSAPP_OUTBOUND_TYPE_ID = 49;
const UNIVERSAL_COLLY_WHATSAPP_OUTBOUND_TYPE_ID = 50;

export function normalizeWhatsappTemplateStatus(status) {
  return (status || '').toUpperCase();
}

export function isWhatsappTemplateApproved(template) {
  return normalizeWhatsappTemplateStatus(template && template.status) === 'APPROVED';
}

export function getWhatsappTemplateStatusLabel(status) {
  const normalized = normalizeWhatsappTemplateStatus(status);
  return WHATSAPP_TEMPLATE_STATUS_LABELS[normalized] || status || 'Sin estado';
}

export function getWhatsappTemplateStatusColor(status) {
  const normalized = normalizeWhatsappTemplateStatus(status);
  return WHATSAPP_TEMPLATE_STATUS_COLORS[normalized] || 'grey lighten-3';
}

export function getWhatsappTemplateStatusTextColor(status) {
  const normalized = normalizeWhatsappTemplateStatus(status);
  return WHATSAPP_TEMPLATE_STATUS_TEXT_COLORS[normalized] || 'grey darken-3';
}

export function formatWhatsappTemplatePhoneLabel(template) {
  const isUniversal = template.phone_type_id === UNIVERSAL_WHATSAPP_OUTBOUND_TYPE_ID
    || template.phone_type_id === UNIVERSAL_COLLY_WHATSAPP_OUTBOUND_TYPE_ID;
  return isUniversal ? 'Número universal' : `+${template.phone}`;
}

export function mapWhatsappTemplateForSelect(template) {
  // Las plantillas de colly no traen teléfono: solo el nombre.
  const hasPhone = template.phone || template.phone_type_id;
  const baseName = hasPhone ? `${template.name} (${formatWhatsappTemplatePhoneLabel(template)})` : template.name;

  return {
    ...template,
    display_name: baseName,
    name: baseName,
    statusLabel: getWhatsappTemplateStatusLabel(template.status),
    statusColor: getWhatsappTemplateStatusColor(template.status),
    statusTextColor: getWhatsappTemplateStatusTextColor(template.status),
    isApproved: isWhatsappTemplateApproved(template),
  };
}

// legacy: lista legacy aunque haya release colly (para validar whatsapp_template_id).
export async function fetchWhatsappTemplatesForSelect(axios, legacy = false) {
  const { data } = await axios.get('whatsapp_templates', {
    params: { paginate: 0, legacy: legacy ? 1 : 0 },
  });

  // Con el release colly_senders_api_whatsapp la API responde { items, pagination }.
  const templates = Array.isArray(data) ? data : (data && data.items) || [];
  return templates.map(mapWhatsappTemplateForSelect);
}

export async function validateWhatsappTemplateForWorkflow(axios, templateId) {
  if (!templateId) {
    return {
      valid: false,
      message: 'Debe seleccionar una plantilla de WhatsApp.',
    };
  }

  const templates = await fetchWhatsappTemplatesForSelect(axios, true);
  const template = templates.find(item => item.id === templateId);

  if (!template) {
    return {
      valid: false,
      message: 'La plantilla de WhatsApp seleccionada no existe.',
    };
  }

  if (!template.isApproved) {
    return {
      valid: false,
      message: `La plantilla de WhatsApp "${template.name}" no está aprobada (${template.statusLabel}).`,
    };
  }

  return { valid: true };
}



// WEBPACK FOOTER //
// ./src/mixins/whatsappTemplateSelect.js